 
import AllRoutes from './components/All Routes/AllRoutes';
// import Carousel from './components/mayank\'s folder/homepage/Carousel/Carousel';
// import Footer from './components/mayankFolder/footer/footer'
// import Homepage from './components/mayankFolder/homepage/Homepage'
// import Navbar from './components/mayankFolder/navbar/Navbar'
// import BackdropExample from './components/mayankFolder/button/button';
import "./App.css";



function App() {
  return (
    <div className="App">
      
      <AllRoutes/>

    </div>
  );
}

export default App;